import React from 'react';

interface LogoProps {
  size?: number;
  isCollapsed?: boolean;
  iconOnly?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export default function Logo({ 
  size = 28, 
  isCollapsed = false,
  iconOnly = false,
  className, 
  style,
  ...props
}: LogoProps & Omit<React.HTMLAttributes<HTMLDivElement>, 'style'>) {
  const collapsed = isCollapsed || iconOnly;

  return (
    <div 
      className={`logo-container-wrapper ${collapsed ? 'collapsed' : ''} ${className || ''}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        height: style?.height || `${size}px`,
        ...style
      }}
      {...props}
    >
      <img
        src="/logo-icon.png"
        alt="Logo Icon"
        className="logo-icon-img"
        style={{
          height: '100%',
          width: 'auto',
          display: 'block',
          flexShrink: 0
        }}
      />
      <img
        src="/logo-text.png"
        alt="Practice Works"
        className="logo-text-img"
        style={{
          height: '85%',
          width: 'auto',
          display: 'block',
          flexShrink: 0
        }}
      />
    </div>
  );
}
